import * as angular from "angular";
import {ILogService, IScope} from "angular";
import './editCondition.scss';
import {CONDITION_SERVICE_NAME} from "../../../utils/names/serviceNames";
import {ConditionService} from "../../services/conditionService";
import {CalculatorCondition} from "../../model/CalculatorCondition";

interface ExportConditionScope extends IScope {
    acceptChanges: (condition: CalculatorCondition) => void;
    cancelChanges: () => void;
    condition: CalculatorCondition;
}

export class EditCondition {
    private $scope: ExportConditionScope;
    private $log: ILogService;
    private $mdDialog: angular.material.IDialogService;
    private conditionsService: ConditionService;
    private originalCondition: CalculatorCondition;

    constructor($scope: ExportConditionScope,
                $log: ILogService,
                $mdDialog: angular.material.IDialogService,
                condition: CalculatorCondition,
                conditionsService: ConditionService) {
        //initialization params
        this.$scope = $scope;
        this.$log = $log;
        this.$mdDialog = $mdDialog;
        this.conditionsService = conditionsService;
        this.originalCondition = Object.assign({}, condition);
        //initialization functions
        $scope.condition = angular.copy(condition);
        $scope.cancelChanges = this.cancelChanges;
        $scope.acceptChanges = this.acceptChanges;
        $log.debug('mounting EditCondition component');
    }

    $onInit = () => {
        this.$log.debug('Finished mounting the EditCondition');
    };

    acceptChanges = (condition: CalculatorCondition) => {
        this.conditionsService
            .updateCondition(condition)
            .then(
                (resp) => {
                    this.$log.debug("Condition response: ", resp.data, " Component value:", this.$scope.condition);
                    this.$mdDialog.hide(resp.data)
                },
                () => this.$mdDialog.hide()
            );
    };

    cancelChanges = () => {
        this.$mdDialog.cancel()
    };

    static getInstance = (event, condition) => {
        return {
            locals: {
                'condition': condition
            },
            controller: [
                '$scope',
                '$log',
                '$mdDialog',
                'condition',
                CONDITION_SERVICE_NAME,
                EditCondition
            ],
            template: require('./editCondition.html'),
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            fullscreen: true
        }
    }
}
